import { apiBlobRequest, apiRequest } from './http';
import type {
  ApiItemResponse,
  ApiListResponse,
  CreateRawDocumentRequest,
  DocumentDetails,
  DocumentListQuery,
  DocumentSummary,
  GenerateDocumentRequest,
  GeneratedDocumentResponse,
} from '../types/api';

function queryString(query: DocumentListQuery): string {
  const search = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      search.set(key, String(value));
    }
  });

  const serialized = search.toString();
  return serialized ? `?${serialized}` : '';
}

export async function listDocuments(query: DocumentListQuery): Promise<ApiListResponse<DocumentSummary>> {
  return apiRequest<ApiListResponse<DocumentSummary>>(`/documents${queryString(query)}`);
}

export async function getDocument(id: string): Promise<DocumentDetails> {
  const response = await apiRequest<ApiItemResponse<DocumentDetails>>(`/documents/${id}`);
  return response.data;
}

export async function downloadDocument(id: string): Promise<{ blob: Blob; filename?: string }> {
  return apiBlobRequest(`/documents/${id}/download`);
}

export async function generateDocument(payload: GenerateDocumentRequest): Promise<GeneratedDocumentResponse> {
  return apiRequest<GeneratedDocumentResponse>('/documents/generate', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function createRawDocument(payload: CreateRawDocumentRequest): Promise<GeneratedDocumentResponse> {
  return apiRequest<GeneratedDocumentResponse>('/documents/raw', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function resendDocument(id: string, reason?: string): Promise<DocumentDetails> {
  const response = await apiRequest<ApiItemResponse<DocumentDetails>>(`/documents/${id}/resend`, {
    method: 'POST',
    body: JSON.stringify({ reason }),
  });
  return response.data;
}

export async function rebuildDocument(id: string, reason?: string, mappingId?: string): Promise<DocumentDetails> {
  const response = await apiRequest<ApiItemResponse<DocumentDetails>>(`/documents/${id}/rebuild`, {
    method: 'POST',
    body: JSON.stringify({ reason, mappingId }),
  });
  return response.data;
}
